import { FiSearch } from "react-icons/fi";

const ExploreProjects = ({ explore, onCategorySelect, title }) => {
  const handleCategorySelect = (category) => {
    if (onCategorySelect) {
      onCategorySelect(category);
    }
  };

  return (
    <div className="mt-5 mb-20">
      <h1 className="text-2xl flex items-center justify-center gap-4 font-semibold mb-10">
        <FiSearch />{title}
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 xl:grid-cols-5  gap-8">
        {explore.map((category, index) => (
          <div key={index} className="text-center">
            <span
              className="text-md font-semibold underline hover:text-blue-500 cursor-pointer"
              onClick={() => handleCategorySelect(category)}
            >
              {category}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExploreProjects;
